"use client";

import { useEffect, useState } from "react";
import { motion, useScroll, useTransform, useReducedMotion, useMotionValueEvent } from "framer-motion";
import { usePortfolioSequence } from "./PortfolioSequence";
import styles from "./cosmic.module.css";
import HeroStars from "./HeroStars";
import PortfolioStars from "./PortfolioStars";

export default function CosmicBackground() {
  const { setPhase } = usePortfolioSequence();
  const { scrollY } = useScroll();
  const reducedMotion = useReducedMotion();
  const [departing, setDeparting] = useState(false);
  useMotionValueEvent(scrollY, "change", () => {
    const portfolio = document.getElementById("portfolio");
    if (!portfolio) return;
    const top = portfolio.getBoundingClientRect().top;
    // Hysteresis prevents replay when the scroll position jitters at the boundary.
    setDeparting(previous => top < window.innerHeight * (previous ? 0.95 : 0.8));
  });
  useEffect(() => {
    if (departing) setPhase(current => current === "idle" ? (reducedMotion ? "done" : "horizon") : current);
  }, [departing, reducedMotion, setPhase]);
  const [viewportHeight, setViewportHeight] = useState(800);
  const [compact, setCompact] = useState(false);
  const progress = useTransform(scrollY, [0, viewportHeight * 0.6], [0, 1]);
  // Starting light is 10% brighter than the previous 0.7 setting; retain the final light.
  const brightness = useTransform(progress, [0, 1], ["brightness(0.77)", "brightness(1.3)"]);
  const glow = useTransform(progress, [0, 1], [0.8, 1]);
  const glowScale = useTransform(progress, [0, 1], [1, compact ? 1.9 : 1.45]);
  const rim = useTransform(progress, [0, 1], [0.8, 1]);

  useEffect(() => {
    const resize = () => {
      setViewportHeight(window.innerHeight);
      setCompact(window.matchMedia("(max-width: 767px)").matches);
    };
    resize();
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);


  return (
    <div
      aria-hidden
      className="pointer-events-none absolute inset-0 overflow-hidden"
    >
      <HeroStars visible={!departing} />
      <PortfolioStars active={departing} />
      <motion.div
        className={styles.horizon}
        style={{ filter: brightness, transformPerspective: 1000, transformOrigin: "50% 20%" }}
        initial={false}
        animate={{ rotateX: departing && !reducedMotion ? 75 : 0, y: departing && !reducedMotion ? "-20%" : "0%", opacity: departing ? 0 : 1 }}
        onAnimationComplete={() => { if (departing) setPhase(current => current === "horizon" ? "ready" : current); }}
        transition={{ duration: reducedMotion ? 0 : 0.65, ease: [0.4, 0, 0.2, 1] }}
      >
        <motion.div className={styles.glowEnvelope} style={{ opacity: glow, scale: glowScale }}>
          <div className={styles.earthGlow} />
        </motion.div>
        <div className={styles.earth} />
        <motion.div className={styles.earthRim} style={{ opacity: rim }} />
      </motion.div>
    </div>
  );
}
